var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSteper1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1015_16993)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5591 4.03516L20.5591 2.86328L6.33478 2.86328L6.33478 1.69141L2.79836 1.69141L2.79836 2.86328L0.440739 2.86328L0.440739 4.03516L2.79836 4.03516L2.79836 5.20703L6.33478 5.20703L6.33478 4.03516L20.5591 4.03516Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.33478 18.1367L20.5591 18.1367L20.5591 16.9648L6.33478 16.9648L6.33478 15.793L2.79836 15.793L2.79836 16.9648L0.440739 16.9648L0.440739 18.1367L2.79836 18.1367L2.79836 19.3086L6.33478 19.3086L6.33478 18.1367Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5591 13.4492L20.5591 12.2773L11.8359 12.2773L11.8359 11.1055L8.29947 11.1055L8.29947 12.2773L0.440739 12.2773L0.440739 13.4492L8.29947 13.4492L8.29947 14.6211L11.8359 14.6211L11.8359 13.4492L20.5591 13.4492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5591 8.72266L20.5591 7.55078L18.4509 7.55078L18.4509 6.37891L14.9145 6.37891L14.9145 7.55078L0.440739 7.55078L0.440739 8.72266L14.9145 8.72266L14.9145 9.89453L18.4509 9.89453L18.4509 8.72266L20.5591 8.72266Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1015_16993"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20.1183,
    fill: "white",
    transform: "translate(20.5591 0.5) rotate(90)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteper1);
export default __webpack_public_path__ + "static/media/steper1.91e2814a558d4c30ebd7ad2940391648.svg";
export { ForwardRef as ReactComponent };